import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { useDispatch, useSelector } from 'react-redux';
import { SuspendedInfo } from 'tradera/apps/tradera/components/profile/suspended-info';
import { Summary } from 'tradera/apps/tradera/components/profile/summary';
import { DetailedSellerRatingsSummary } from 'tradera/apps/tradera/components/profile/detailed-seller-ratings-summary';
import { SearchPagination } from 'tradera/apps/tradera/components/profile/search-pagination';
import { FeedbackItem } from 'tradera/apps/tradera/components/profile/feedback-item';
import { FeedbackItemsHeader } from 'tradera/apps/tradera/components/profile/feedback-items-header';
import ScrollToTopButton from '../../../legacy/static/components/shared/scroll-to-top-button';
import {
    selectProfileFeedbackModel,
    selectIsLoadingFeedbackModel,
    showLoading
} from 'tradera/state/views/profile/selectors';
import { fetchProfileFeedbackModel } from 'tradera/state/views/profile/actions';
import { LocalLoader } from 'tradera/components/loader/loader';
import { toQueryParameters } from 'tradera/utils/url';

const ProfileFeedbackPage = ({ location, match }) => {
    const dispatch = useDispatch();
    const { memberId } = match?.params;
    const model = useSelector(selectProfileFeedbackModel);
    const isLoadingFeedbackModel = useSelector(selectIsLoadingFeedbackModel);
    const isLoadingTranslation = useSelector(showLoading);
    useEffect(() => {
        const { role, rating, page } = toQueryParameters(location.search);
        dispatch(fetchProfileFeedbackModel({ memberId, role, rating, page }));
    }, [dispatch, location.search, memberId]);

    return (
        <div className="profile-page container">
            {(isLoadingFeedbackModel || isLoadingTranslation) && (
                <LocalLoader />
            )}
            {model && (
                <>
                    <SuspendedInfo model={model} />
                    <section className="profile-page-feedback-overview row">
                        <div className="col-12 col-md-6">
                            <div className="profile-page-feedback-summary">
                                <Summary model={model} />
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="profile-page-feedback-summary">
                                <DetailedSellerRatingsSummary model={model} />
                            </div>
                        </div>
                    </section>

                    <section className="profile-page-feedback">
                        <FeedbackItemsHeader model={model} />
                        <div className="profile-page-feedback-body">
                            <SearchPagination
                                pagination={model.pagination}
                                onlyPreviousLink={true}
                            />
                            <ul className="feedback-items plain-list">
                                {model.feedbackItems.map((feedbackItem) => (
                                    <FeedbackItem
                                        key={feedbackItem.gradeId}
                                        feedbackItem={feedbackItem}
                                    />
                                ))}
                            </ul>
                        </div>
                    </section>
                    <SearchPagination
                        pagination={model.pagination}
                        onlyPreviousLink={false}
                    />
                    {model.feedbackItems.some((i) => i) && (
                        <div>
                            <ScrollToTopButton />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default hot(module)(ProfileFeedbackPage);
